const DUAL_MODE_PREFIX = 'professional_dual_mode_prompt_seen_';

export function buildProfessionalDualModeKey(userId) {
  if (!userId) return null;
  return `${DUAL_MODE_PREFIX}${userId}`;
}

export function clearProfessionalDualModeChoice(userId) {
  const key = buildProfessionalDualModeKey(userId);
  if (!key) return;
  localStorage.removeItem(key);
}

export function clearAllProfessionalDualModeChoices() {
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(DUAL_MODE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}

